import React from 'react';
import {IMultiSelectProps, ISelectProps, MultiSelectInput, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {TableSortDirection} from '~/components/Table';
import {Intent} from '~/lib/intent';
import {ID} from '~/lib/model';
import {sortByNumber, sortByString} from '~/lib/sort';
import {useSourcePreviewsQuery} from '~/modules/Bidders/queries';

type ISelectSourceProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectSource = ({
    disabled,
    ...props
}: ISelectSourceProps) => {
    const {data: sources = [], isLoading} = useSourcePreviewsQuery();

    return <SelectInput {...props} disabled={disabled || isLoading}
        rightIcon={isLoading && !disabled && <i className='fa fa-spinner fa-spin'/>}
        items={sortByString(sources
            .filter(source => source.name)
            .map(source => ({
                label: source.name || `ID: ${source.id}`,
                value: source.id
            })), 'label', TableSortDirection.ASC)}/>;
};

export const SelectSourceField = (props: IFieldProps<ISelectSourceProps>) => <FormField {...props}>
    <SelectSource {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;

type IMultiSelectSourceProps = Omit<IMultiSelectProps<number>, 'items'>;

export const MultiSelectSource = ({disabled, ...props}: IMultiSelectSourceProps) => {
    const {data: sources = [], isLoading} = useSourcePreviewsQuery();

    return <MultiSelectInput
        {...props}
        disabled={disabled || isLoading}
        rightIcon={isLoading && !disabled && <i className='fa fa-spinner fa-spin'/>}
        searchable
        items={sortByNumber(
            sources.filter(s => s.name).map(s => ({label: `${s.id} · ${s.name}`, value: s.id})),
            'value',
            TableSortDirection.ASC
        )}
    />;
};
